<!-- base web header -->
<ng-container #headerContainer></ng-container>
<!-- edit-err: MobileWeb端、PCWeb端错误页样式适配 -->
<div [ngClass]="{'edit-err': isShowHeaderAndFooter && showError && isNotlanding}">
<!-- 
  pc-web: PCWeb端样式适配
  pc-web-login: PCWeb端“登录/注册流程”样式适配：展示蓝底背景图
  edit-profile-web: PCWeb端“编辑流程”样式适配：需要展示header和footer、展示灰底背景
  edit-profile-mobile: MobileWeb端“编辑流程”样式适配：需要展示header和footer
  gr-mo-profile: PCWeb端为 GR/MO 特殊处理的样式：不展示header和footer
  com-big-page: 手机横屏模式/IPad下样式适配
 -->
  <div class="common-body " [ngClass]="{
    'pc-web': factorySer.isWebStyle || (isPcWeb && isGuestPage),
    'pc-web-login':isWebLoginBg, 
    'edit-profile-web': isPcHeader && isNotlanding,
    'edit-profile-mobile': isMbileHeader, 
    'gr-mo-profile': factorySer.isNotHeaderFooter, 
    'com-big-page': showBigView || isHorizonScreen}">
    <router-outlet></router-outlet>
  </div>
  
  <!-- only for common single popup with one btn -->
  <ng-container *ngIf="factorySer.showSinglePop">
    <com-pop
      [descPip]="factorySer.descPip"
      [popTitle]="factorySer.popTitle"
      [popDesc]="factorySer.popMsg"
      [showClose]="false"
      (btnActionEmit)="btnAction('cancel')">
    </com-pop>
  </ng-container>

  <ng-container  *ngIf="showError">
    <com-error [mobileStye]="isGuestPage"></com-error>
  </ng-container>
</div>

  <com-toast 
    [showToast]="factorySer.showToast"
    [text]="factorySer.toastText" 
    [marginBtm]="factorySer.toastMarginBtm"
    [successFlag]="factorySer.toastSuccessFlag"
    [type]="factorySer.toastType">
  </com-toast>

<ng-container *ngIf="showForgetPwdPop">
  <com-pop 
        popKey="forgetPwd"
        [popTitle]="'Profile.Common.ForgetPwd.Label'"
        [popDesc]="'Profile.ForgetPwd.Popup.Desc'"
        [popBtn1]="'Profile.ForgetPwd.Popup.Btn.UsePhone'"
        [popBtn2]="'Profile.ForgetPwd.Popup.Btn.UseEmail'"
        [showBtn3]='!factorySer.isWebStyle'
        (btnActionEmit)="btnAction($event)">
  </com-pop>
</ng-container>

<ng-container  *ngIf="showLoading">
  <com-loading> </com-loading>
</ng-container>

<ng-container *ngIf="showCaptcha">
  <com-captcha class="com-captcha-box"
          (passEmit)="captchaEmit($event, 'pass')"
          (limitEmit)="captchaEmit(null, 'limit')">
  </com-captcha>
</ng-container>
  

<!-- for check virtual-phone -->
<ng-container *ngIf="showVirtualPhonePop">
  <warn-pop
          [innerFlag]=true
          [warnDesc]="'Profile.VirtualPhone.Popup.Desc'" 
          [noteTitle]="'Profile.Common.Txt.Reminder'" 
          (btnActionEmit)="btnAction()">
  </warn-pop>
</ng-container>
<!-- base web footer -->
<ng-container #footerContainer></ng-container>
<ng-container #iconSymbolContainer></ng-container>